module.exports = __webpack_public_path__ + "media/audio.56aeca21.mp3";